/* unplugin-vue-components disabled */import script from "./TrainDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrainDialog.vue?vue&type=script&lang=ts&setup=true"

import "./TrainDialog.vue?vue&type=style&index=0&id=4058b7c1&lang=scss"

const __exports__ = script;

export default __exports__